const PlayerStats = () => import('./PlayerStats')

export default function installComponents(Vue) {
  Vue.component('PlayerStats', PlayerStats)
}
